import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import PropTypes from "prop-types";
import { useEffect } from "react";
import Skeleton from "react-loading-skeleton";

import { Badge, Card, CardBody, CardHeader, ToastType } from "@features/ui";

import { useCareerPlans } from "../api/use-career-plans";
import { PathwaysList } from "./pathways.list";

import "./pathways.card.scss";

export const PathwaysCard = ({ onDownloadClicked, onError }) => {
  const {
    data: careerPlans,
    isFetching: fetchingCareerPlans,
    isError: fetchingCareerPlansError,
    refetch: refetchCareerPlans,
  } = useCareerPlans();

  useEffect(() => {
    if (fetchingCareerPlansError) {
      onError({
        type: ToastType.error,
        message:
          "Something went wrong while fetching your career pathways. Please try again.",
      });
    }
  }, [fetchingCareerPlansError, onError]);

  const retryCareerPlans = () => {
    onError();
    refetchCareerPlans();
  };

  return (
    <Card className="pathways-card">
      <CardHeader
        className="pathways-card-header"
        title={
          <>
            <h1>
              <FontAwesomeIcon icon={["fasr", "signs-post"]} />
              <span>Pathways</span>
              {fetchingCareerPlans ? (
                <Skeleton width="1.5rem" height="2rem" />
              ) : (
                careerPlans?.length > 0 && <Badge>{careerPlans.length}</Badge>
              )}
            </h1>
            <div className="subheader">Download career pathway details.</div>
          </>
        }
      />
      <CardBody
        className={clsx(
          "pathways-card-body",
          fetchingCareerPlansError && "error",
        )}
      >
        <PathwaysList
          careerPlans={careerPlans}
          isLoading={fetchingCareerPlans}
          isError={fetchingCareerPlansError}
          onDownloadClicked={onDownloadClicked}
          onRetry={retryCareerPlans}
        />
      </CardBody>
    </Card>
  );
};

PathwaysCard.propTypes = {
  onDownloadClicked: PropTypes.func,
  onError: PropTypes.func,
};
